/**
 * 功能：类型转换处理
 * 类型：
 *      time：  时间
 *      dict：  字典
 *      number：数值
 */

import * as common from "./Slot/Common.js"
import * as dict from "./Slot/Dict.js"
import * as time from "./Slot/Time.js"
import * as number from "./Slot/Number.js"

// 初始化
export function initialize(column)
{
  switch (column.dataType)
  {
    // 字典
    case "dict":
      dict.initialize(column);
      break;
    default:
      break;
  }
}

// 格式化
export function format(column, value)
{
  switch (column.dataType)
  {
    // 时间
    case "time":
      value = time.format(column, value);
      break;
    // 字典
    case "dict":
      value = dict.format(column, value);
      break;
    // 数值
    case "number":
      value = number.format(column, value);
      break;
    default:
      break;
  }
  // 公共
  return common.format(column, value);
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableColumn/Slot.js